import CheckoutSuccess from "./CheckoutSuccess";

export default CheckoutSuccess;
